import * as React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg, { Path, G, LinearGradient, Stop } from 'react-native-svg';

const MB_SVG_File = React.memo((props: {
    /**
     * The size of the component.
     */
    size?: number,

    /**
     * The color of the component.
     */
    color?: string,

    /**
     * The style of the component's container.
     */
    containerStyle?: StyleProp<ViewStyle>
}) => {
    return (
        <View style={props.containerStyle}>
            <Svg
                width={props.size ?? 256}
                height={props.size ?? 256}
                viewBox="0 0 256 256"
            >
                <G
                    transform="matrix(2.81 0 0 2.81 1.407 1.407)"
                    stroke="none"
                    strokeWidth={0}
                    strokeDasharray="none"
                    strokeLinecap="butt"
                    strokeLinejoin="miter"
                    strokeMiterlimit={10}
                    fill="none"
                    fillRule="nonzero"
                    opacity={1}
                >
                    <Path
                        d="M77.474 17.28L61.526 1.332A4.516 4.516 0 0058.311 0H15.742a4.553 4.553 0 00-4.548 4.548v80.904A4.553 4.553 0 0015.742 90h58.516a4.554 4.554 0 004.549-4.548V20.496a4.517 4.517 0 00-1.333-3.216zM61.073 5.121l12.611 12.612H62.35a1.278 1.278 0 01-1.276-1.277V5.121zM74.258 87H15.742a1.55 1.55 0 01-1.548-1.548V4.548A1.55 1.55 0 0115.742 3h42.332v13.456a4.281 4.281 0 004.276 4.277h13.457v64.719A1.55 1.55 0 0174.258 87z"
                        stroke="none"
                        strokeWidth={1}
                        strokeDasharray="none"
                        strokeLinecap="butt"
                        strokeLinejoin="miter"
                        strokeMiterlimit={10}
                        fill={props.color ?? "#000"}
                        fillRule="nonzero"
                        opacity={1}
                    />
                    <Path
                        d="M68.193 33.319H41.808a1.5 1.5 0 110-3h26.385a1.5 1.5 0 110 3zM34.456 33.319H21.807a1.5 1.5 0 110-3h12.649a1.5 1.5 0 110 3z"
                        stroke="none"
                        strokeWidth={1}
                        strokeDasharray="none"
                        strokeLinecap="butt"
                        strokeLinejoin="miter"
                        strokeMiterlimit={10}
                        fill={props.color ?? "#000"}
                        fillRule="nonzero"
                        opacity={1}
                    />
                    <LinearGradient
                        id="a"
                        gradientUnits="userSpaceOnUse"
                        x1={21.8064}
                        y1={19.2332}
                        x2={42.2984}
                        y2={19.2332}
                    >
                        <Stop offset="0%" stopColor="#fff" stopOpacity={1} />
                        <Stop offset="100%" stopColor={props.color ?? "#000"} stopOpacity={1} />
                    </LinearGradient>
                    <Path
                        d="M-10.246 0L10.246 0"
                        stroke="none"
                        strokeWidth={1}
                        strokeDasharray="none"
                        strokeLinecap="butt"
                        strokeLinejoin="miter"
                        strokeMiterlimit={10}
                        fill="url(#a)"
                        fillRule="nonzero"
                        opacity={1}
                    />
                    <Path
                        d="M42.298 20.733H21.807a1.5 1.5 0 110-3h20.492a1.5 1.5 0 11-.001 3zM68.193 44.319H21.807a1.5 1.5 0 110-3h46.387a1.5 1.5 0 11-.001 3zM48.191 55.319H21.807a1.5 1.5 0 110-3h26.385a1.5 1.5 0 01-.001 3zM68.193 55.319H55.544a1.5 1.5 0 010-3h12.649a1.5 1.5 0 010 3zM68.193 66.319H21.807a1.5 1.5 0 110-3h46.387a1.5 1.5 0 01-.001 3zM68.193 77.319H55.544a1.5 1.5 0 010-3h12.649a1.5 1.5 0 010 3z"
                        stroke="none"
                        strokeWidth={1}
                        strokeDasharray="none"
                        strokeLinecap="butt"
                        strokeLinejoin="miter"
                        strokeMiterlimit={10}
                        fill={props.color ?? "#000"}
                        fillRule="nonzero"
                        opacity={1}
                    />
                </G>
            </Svg>
        </View>
    );
});

export { MB_SVG_File };
